import React from "react";
import FeatureGraphicPage from "./FeatureGraphicPage";

/**
 * 1080p ending capture — feature graphic covers the full 1920×1080 frame.
 * Open from PrototypeMain → 1080P - ENDING.
 */
export default function FeatureGraphicEndingPage() {
    return <FeatureGraphicPage endingCapture />;
}
